import { render, staticRenderFns } from "./ProductScreen.vue?vue&type=template&id=ed3a231c&scoped=true&"
import script from "./ProductScreen.vue?vue&type=script&lang=js&"
export * from "./ProductScreen.vue?vue&type=script&lang=js&"
import style0 from "./ProductScreen.vue?vue&type=style&index=0&id=ed3a231c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3a231c",
  null
  
)

export default component.exports